/******************************************************
 * THIS SCRIPT MAKES SURE THAT ITEMS CANNOT BE ADDED
 * TO THE CART IF THE SHIRT OF THE MONTH IS IN THE
 * CART. ADDITIONALLY, THE SHIRT OF THE MONTH MAY NOT
 * BE ADDED TO THE CART IF OTHER ITEMS ARE THERE.
 *****************************************************/
(() => {
    // Flag to allow programmatic re-click of ATC button
    let allowAtc = false;

    window.addEventListener('click', (e) => {
        // If click is NOT ATC button, do nothing
        if (!e.target.matches('form[action="/cart/add"] button[name="add"], form[action="/cart/add"] button[name="add"] *, button.ws_Product_Button, button.ws_Product_Button *')) return;

        // If this is the programmatic re-click, let it through
        if (allowAtc) {
            allowAtc = false;
            return;
        }

        // Prevent ATC until we check the cart contents
        e.preventDefault();
        e.stopImmediatePropagation();

        // Get cart data, then run conditional logic
        fetch("/cart.js")
            .then((r) => r.json())
            .then((cart) => {
                // If SOTM is in the cart, don't allow adding any other items
                if (cart.items.length > 0 && cart.items.some((item) => item.handle === "shirt-of-the-month")) {
                    //console.log("SOTM is in the cart, preventing adding other items.");
                    alert("You cannot add other items to the cart while Shirt of the Month is in the cart.");
                } 
                // If other items are in the cart, don't allow adding SOTM
                else if (cart.items.length > 0 && (location.pathname.includes('shirt-of-the-month') && e.target.closest('.product__info-container'))) {
                    alert("You cannot add Shirt of the Month to the cart while other items are in the cart.");
                } 
                // Otherwise, act normally
                else {
                    // Allow adding the item to the cart
                    allowAtc = true;
                    e.target.closest('button').click();
                }
            });
    }, { capture: true });
})();